module.exports = "# Ian and Sara Intro\n\nYouTube: 2QttQl5KktI\n\n## Notes\nIntro to Esmeralda and Goober Opening Story (0:49).\n\n# Esmeralda and Goober Opening Story\n\nYouTube: 0Asyn4VAp-s\n\n## Notes\nEsmeralda teaches Goober about packaging and why it's a problem (1:55).\n\n# Disposable Rap Intro\n\nYouTube: iYTqwolZ7X8\n\n## Notes\nIntro to Disposable Rap (1:28).\n\n# Disposable Rap\n\nYouTube: 7ZCAYQJ_NBA\n\n## Notes\n\nDisposable Rap: a fun rap video about single-use plastics (2:59).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level4_opening.md
// module id = 1838
// module chunks = 2